export default __webpack_public_path__ + "static/media/barn-logo-gray-400.54a708d4.svg";